/* CalmOrbit hero behaviour — gallery, quantity, variant switching, sticky ATC.
   Initialises every [data-co-hero] once; re-runs on Shopify section load so it
   works while editing/reordering in the theme editor. Add-to-cart itself is
   handled by Dawn's <product-form> element + the cart drawer. */
(function () {
  function moneyFmt(cents) {
    var fmt = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    if (fmt.indexOf('{{amount}}') > -1) return fmt.replace('{{amount}}', amount);
    if (fmt.indexOf('{{ amount }}') > -1) return fmt.replace('{{ amount }}', amount);
    return '$' + amount;
  }

  function initHero(root) {
    if (!root || root.dataset.coInit) return;
    root.dataset.coInit = '1';
    var sectionId = root.getAttribute('data-section-id');

    // Gallery
    var slides = root.querySelectorAll('[data-co-slide]');
    var thumbs = root.querySelectorAll('[data-co-thumb]');
    function show(i) {
      slides.forEach(function (s) { s.classList.toggle('co-active', s.dataset.coSlide == i); });
      thumbs.forEach(function (t) { t.classList.toggle('co-active', t.dataset.coThumb == i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.coThumb); }); });

    // Quantity
    var qi = root.querySelector('[data-co-qty-input]');
    var minus = root.querySelector('[data-co-qty-minus]');
    var plus = root.querySelector('[data-co-qty-plus]');
    if (minus) minus.addEventListener('click', function () { qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; });

    // Variants
    var dataEl = root.querySelector('[data-co-variants-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var optionInputs = root.querySelectorAll('[data-co-opt]');
    var hiddenId = root.querySelector('[data-co-variant-id]');
    var priceNode = root.querySelector('[data-co-price]');
    var compareNode = root.querySelector('[data-co-compare]');
    var saveNode = root.querySelector('[data-co-save]');
    var atcBtn = root.querySelector('[data-co-atc]');
    var atcText = root.querySelector('[data-co-atc-text]');
    var stockNote = root.querySelector('[data-co-stock] span');
    var sticky = document.getElementById('co-sticky-' + sectionId);
    var stickyPrice = sticky && sticky.querySelector('[data-co-sticky-price]');
    var CTA = root.getAttribute('data-cta') || 'Add to Cart';
    var SOLD = root.getAttribute('data-sold') || 'Sold out';
    var IN = root.getAttribute('data-instock') || 'In stock';

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('[data-co-variants] .co-vgroup').forEach(function (g) {
        var checked = g.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
        var sel = g.querySelector('[data-co-option-selected]');
        if (sel && checked) sel.textContent = checked.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      if (!optionInputs.length) return;
      var v = findVariant(selectedOptions());
      if (!v) { if (atcBtn) { atcBtn.disabled = true; atcText.textContent = 'Unavailable'; } return; }
      hiddenId.value = v.id;
      priceNode.textContent = moneyFmt(v.price);
      if (stickyPrice) stickyPrice.textContent = moneyFmt(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareNode.hidden = false; compareNode.textContent = moneyFmt(v.compare_at_price);
        saveNode.hidden = false; saveNode.textContent = 'SAVE ' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
      } else { compareNode.hidden = true; saveNode.hidden = true; }
      if (atcBtn) { atcBtn.disabled = !v.available; atcText.textContent = v.available ? CTA : SOLD; }
      if (stockNote) stockNote.textContent = v.available ? IN : SOLD;
      if (history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    optionInputs.forEach(function (inp) { inp.addEventListener('change', update); });

    // Sticky ATC
    var atcZone = root.querySelector('.co-actions');
    if (sticky && atcZone && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { sticky.classList.toggle('co-show', !e[0].isIntersecting); }, { rootMargin: '-10px 0px 0px 0px' });
      io.observe(atcZone);
      var add = sticky.querySelector('[data-co-sticky-add]');
      if (add) add.addEventListener('click', function () { if (atcBtn) atcBtn.click(); });
    }
  }

  function scan(scope) { (scope || document).querySelectorAll('[data-co-hero]').forEach(initHero); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); });
  else scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
